import React, { useContext } from "react";
import { MenuSelection } from "../../../components/menuButtons/MenuSelection";
import { SaveImage } from "../../../components/SaveImage";
import { Loader } from "../../../components/loader/Loader";
import { LocalStoreContext } from "../store/LocalStore";
import { StoreContext } from "../../../store/Store";
import { RefContext } from "../store/RefContext";
import { LegendItem } from "../../../components/LegendItem";

export const Controls = () => {
  const [store] = useContext(StoreContext);
  const [lstore] = useContext(LocalStoreContext);
  const { loading } = lstore;
  const { defaultTicker } = store;
  const refs = useContext(RefContext);
  return (
    <div
      style={{
        height: refs.componentSize.current["Controls"].height,
        width: refs.componentSize.current["Controls"].width - 17,
        margin: 0,
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        gap: 0,
      }}
    >
      <div style={{ width: 30 }}></div>
      <MenuSelection
        menukey="storedValueTicker"
        defaultSelection={defaultTicker}
        label="Ticker"
        inputType="radio"
        data={["nothing needed"]}
      />
      <div style={{ width: 30 }}>{loading && <Loader width={20} />}</div>
      <MenuSelection
        menukey="storedValueHorizon"
        defaultSelection={"21"}
        label="Horizon"
        inputType="radio"
        data={["nothing needed"]}
      />
      <div style={{ width: 30 }}></div>
      <div style={{ display: "flex", justifyContent: "start", gap: 20 }}>
        <LegendItem colour="#FF9DA7" label="Sigma_95" />
        <LegendItem colour="#E15759" label="Sigma_99" />
        <LegendItem colour="#AFD6ED" label="Vector_95" />
        <LegendItem colour="#2A5783" label="Vector_99" />
      </div>
      <div style={{ width: 30 }}></div>
      {!loading && (
        <SaveImage
          label="Download Stored Value"
          prefix="StoredValue"
          selectkeys={["storedValueHorizon", "storedValueTicker"]}
          svgRef={refs.storedValueRef}
        />
      )}
    </div>
  );
};
